
import React from 'react';
import { Page, Document, Text,View, StyleSheet, Image, Font } from '@react-pdf/renderer';
import * as moment from "moment";
import logo from "../../../Assets/Images/logo.png";
import font from '../../../Assets/fonts/Poppins-Regular.ttf'

Font.register({ family: 'Poppins', src: font });

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    paddingTop: 20,
    paddingLeft: 20,
    paddingBottom: 20,
    paddingRight: 20,
    fontSize: 11,
    fontFamily: 'Poppins'
},
    logo: {
        width: 100,
        height: 'auto',
    },
    row: {
      flexDirection: 'row',
      alignItems: 'center',
      padding: '10px 5px 5px 10px',
      borderBottom:'0.1 solid #000',
      color: '#111827'
  },
  rowheader: {
      flexDirection: 'row',
      alignItems: 'center',
      backgroundColor: '#2370b7',
      color: '#fff',
      padding: '10px 5px 10px 10px',
      borderTop:'.1 solid #000',
      borderBottom:'.1 solid #000'
  },
  description: {
      width: '30%',
  },
  other: {
      width: '14%',
  },
  red: {
    color: 'red',
    width: '14%',
  },
  green: {
    color: 'green',
    width: '14%',
  },
  tableContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
},
header: {
  flexDirection: 'row',
  flexWrap: 'wrap',
  alignItems: 'center',
  padding: 10,
  paddingBottom: 20,
  justifyContent: 'space-between',
},
headerText: {
  fontSize: 18,
  color: '#000',
  fontWeight: 800
},
footer: {
  flexDirection: 'row',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: 10,
  paddingTop: 20,
},
footerText: {
  paddingLeft: 50,
  fontSize: 10,
  color: '#babac4',
}
  });
  
  const LocationReportPDF = (val) => (
              <Document>
    <Page size="A4" style={styles.page}>
    <View style={styles.header}>
      <Image src={logo} style={styles.logo}/>
      <Text style={styles.headerText}>Location Performance Report</Text>
      </View>
    <View style={styles.tableContainer}>
    <View style={styles.rowheader} key="">
            <Text style={styles.description}>Location</Text>
            <Text style={styles.other}>Users</Text>
            <Text style={styles.other}>Task</Text>
            <Text style={styles.other}>Completed</Text>
            <Text style={styles.other}>Escalated</Text>
            <Text style={styles.other}>Seal Count</Text>
        </View>
    {val.val.map( item => 
        <View style={styles.row} key={item.location_name.toString()}>
            <Text style={styles.description}>{item.location_name}</Text>
            <Text style={styles.other}>{item.users || 0}</Text>
            <Text style={styles.other}>{item.count || 0}</Text>
            <Text style={styles.green}>{item.completed || 0}</Text>
            <Text style={styles.red}>{item.escalated || 0}</Text>
            <Text style={styles.other}>{Math.ceil((item.completed/item.count) * 100) || `0`}%</Text>
        </View>) }
        </View>
        <View style={styles.footer}>
      <Image src={logo} style={styles.logo}/>
      <Text style={styles.footerText}>Copyright © {moment().format("YYYY")} SanAttest™. All rights reserved.</Text>
      </View>
    </Page>
  </Document>
  );
 
    export default LocationReportPDF;